import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllPolicies,
  addPolicy,
  removePolicy,
  updatePolicy,
} from '../actions/policy.action'
import { Policy, UpdatePolicyThunkParams } from '@dataTypes/index'

type PolicyState = {
  data: Policy[] | null
  loading: boolean
  error: null
}

const initialState: PolicyState = {
  data: null,
  loading: false,
  error: null,
}

const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllPolicies.fulfilled,
      (state, action: PayloadAction<Policy[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllPolicies.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllPolicies.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      addPolicy.fulfilled,
      (state, action: PayloadAction<Policy>) => {
        state.data = state.data
          ? [...state.data, action.payload]
          : [action.payload]
        state.loading = false
      },
    )
    builder.addCase(addPolicy.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addPolicy.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updatePolicy.fulfilled,
      (state, action: PayloadAction<UpdatePolicyThunkParams>) => {
        const { id, body: updatedPolicy } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedPolicy }
        }
        state.loading = false
      },
    )
    builder.addCase(updatePolicy.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updatePolicy.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removePolicy.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removePolicy.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removePolicy.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default policiesSlice.reducer
